export default "__VITE_ASSET__BKXBeIKc__"